import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { Submission } from '../submission.js';

@Entity()
export class UpdateSubmissionImageIdsResult extends AdornisEntity {
  static override _class = 'UpdateSubmissionImageIdsResult';

  @Field(() => Boolean)
  success!: boolean;

  @Field(() => String)
  message!: string;
}

export const updateSubmissionImageIdsMutation = registerMutation({
  operationName: 'updateSubmissionImageIdsMutation',
  type: () => UpdateSubmissionImageIdsResult,
  params: [
    { name: 'submissionId', type: () => String },
    { name: 'imageIds', type: () => [String] },
    { name: 'studentName', type: () => String },
  ],
  resolve:
    (submissionId: string, imageIds: string[], studentName?: string) =>
    async (_gqlFields: BaseQLSelectionSet<UpdateSubmissionImageIdsResult>) => {
      const submissionCollection = await getCollection(Submission);

      const normalizedStudentName =
        typeof studentName === 'string' && studentName.trim().length > 0 ? studentName.trim() : undefined;

      const setPayload: { imageIds: string[]; studentName?: string } = { imageIds };
      if (normalizedStudentName !== undefined) {
        setPayload.studentName = normalizedStudentName;
      }

      const result = await submissionCollection.updateOne(
        { _id: submissionId },
        {
          $set: setPayload,
        },
      );

      if (!result.matchedCount) {
        return new UpdateSubmissionImageIdsResult({
          success: false,
          message: `Submission with ID ${submissionId} not found.`,
        });
      }

      return new UpdateSubmissionImageIdsResult({
        success: true,
        message: 'Submission imageIds updated.',
      });
    },
});
